import {Box} from '@mui/material';
import {useQuery} from '@tanstack/react-query';
import ChartCard from './components/ChartCard';
import ComparisonColumns from './components/ComparisonColumns';
import DashboardState, {CARD_GRID} from './components/DashboardState';
import {fetchAttentamenteDashboard} from './utils/api';
import {CHARTS} from './utils/labels';
import {asSingleCategory, sizes, SINGLE_CATEGORY} from './utils/single';
import {ACTIVITIES_MAPPING} from './utils/surveys';
import {ActivitiesData} from './utils/types';
import {useAttentamente2024Auth} from './utils/useAttentamente2024Auth';

const Attentamente2024Activities = () => {
    const {container, uoaId, surveyIds, isAuthorized} = useAttentamente2024Auth(['previsioned_id', 'actual_id']);

    const {data, isLoading, isError} = useQuery<ActivitiesData>({
        queryKey: ['attentamente-2024-activities', container, uoaId, surveyIds],
        queryFn: () => fetchAttentamenteDashboard(container!, uoaId!, 'activities', {...surveyIds, ...ACTIVITIES_MAPPING}),
        enabled: isAuthorized,
        staleTime: 5 * 60 * 1000,
    });

    return (
        <DashboardState isAuthorized={isAuthorized} isLoading={isLoading} isError={isError || (!isLoading && !data)} cards={1}>
            {() => (
                <Box sx={CARD_GRID}>
                    <ChartCard {...CHARTS.reachRate} n={sizes(data!.reach_rate)}>
                        <ComparisonColumns categories={SINGLE_CATEGORY} data={asSingleCategory(data!.reach_rate)} suffix='%' />
                    </ChartCard>
                </Box>
            )}
        </DashboardState>
    );
};

export default Attentamente2024Activities;
